import { render, staticRenderFns } from "./BtnTag.vue?vue&type=template&id=75309605&"
import script from "./BtnTag.vue?vue&type=script&lang=js&"
export * from "./BtnTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports